









import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { IError } from '../store/types/IRootState';
import ImageComponent from './ImageComponent.vue';

@Component({
  components: {
    ImageComponent,
  },
})
export default class ErrorComponent extends Vue {

  @Getter
  public getError!: IError;

}
